import { experimentsFlags, CalendarFilterVariants } from './config';
import {
  checkExperimentVariant,
  checkCachedExperimentVariant,
  getCurrentVariant,
  getExperimentPayload,
} from './lib';

export const amplitudeExperiment = {
  lib: {
    checkExperimentVariant,
    checkCachedExperimentVariant,
    getCurrentVariant,
    getExperimentPayload,
  },
  config: {
    flags: experimentsFlags,
    variants: {
      CalendarFilterVariants,
    },
  },
};
